import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../feathers-client';
import i18n from '../i18n';

const servicePath = 'users';

const Model = class User extends BaseModel {
  static modelName = 'User';

  static instanceDefaults() {
    return {
      email: '',
      password: '',
      // displayName: '',
      color: '',
      roleIds: [],
      locale: i18n.locale,
    };
  }
  
  get displayName() {
    return `${this.FirstName} ${this.LastName}`;
  }
  
  set displayName(name) {}
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
